import { ChangeEvent, memo } from 'react'
import { Form } from 'react-bootstrap'
import { FormikErrors, FormikTouched } from 'formik'
import { IArbitrationForm, IDropdownItem } from 'types/arbitrationTypes'
import { FormFieldInput } from '../FormFieldInput'

interface IProps {
  values: IArbitrationForm
  errors: FormikErrors<IArbitrationForm>
  touched: FormikTouched<IArbitrationForm>
  handleChange: (e: ChangeEvent) => void
  contactMethods: IDropdownItem[]
  isUpdateAttachment: boolean
  hasAttemptedSubmit: boolean
}

export const ContactInfoSection = memo(function ContactInfoSection({
  values,
  errors,
  touched,
  handleChange,
  contactMethods,
  isUpdateAttachment,
  hasAttemptedSubmit
}: IProps) {
  return (
    <>
      <div className="px-3 py-2">
        <h6 className="font-weight-bold">Contact Information</h6>
      </div>
      <div className="arbitration-container">
        <FormFieldInput
          label="Name:"
          name="name"
          isInvalid={!!errors.name && (!!touched.name || hasAttemptedSubmit)}
          handleChange={handleChange}
          defaultValue={values.name}
          error={errors.name}
          readOnly={isUpdateAttachment}
          isRequired={!isUpdateAttachment}
        />
        <FormFieldInput
          label="Email:"
          name="email"
          isInvalid={!!errors.email && (!!touched.email || hasAttemptedSubmit)}
          handleChange={handleChange}
          defaultValue={values.email}
          error={errors.email}
          readOnly={isUpdateAttachment}
          isRequired={!isUpdateAttachment}
        />
      </div>
      <div className="arbitration-container">
        <FormFieldInput
          label="Phone Number:"
          name="phoneNumber"
          isInvalid={!!errors.phoneNumber && (!!touched.phoneNumber || hasAttemptedSubmit)}
          handleChange={handleChange}
          defaultValue={values.phoneNumber}
          error={errors.phoneNumber}
          readOnly={isUpdateAttachment}
          isRequired={!isUpdateAttachment}
        />
        <div className="arbitration-field">
          <label>Contact Method:</label>
          <div className="input-context">
            <Form.Control
              as="select"
              name="contactMethodID"
              value={values.contactMethodID}
              onChange={handleChange}
              disabled={isUpdateAttachment}
            >
              <option value={0}>-- Select --</option>
              {contactMethods?.map((item) => (
                <option key={item.ID} value={item.ID}>
                  {item.Description}
                </option>
              ))}
            </Form.Control>
          </div>
        </div>
      </div>
      <hr />
    </>
  )
})
